import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { adminDeleteSession, adminSessions } from '../../api/endpoints';
import TopBar from '../../components/TopBar';
import Splash from '../../components/Splash';
import { formatDateTime } from '../../lib/format';
import { showAlert, showConfirm } from '../../lib/tg';

export default function SessionsList() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [archive, setArchive] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: ['admin-sessions', archive],
    queryFn: () => adminSessions(archive),
  });

  const delMut = useMutation({
    mutationFn: (id: number) => adminDeleteSession(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-sessions'] }),
    onError: (e: any) => {
      const detail = e?.response?.data?.detail;
      showAlert(typeof detail === 'string' ? detail : 'Не удалось удалить');
    },
  });

  if (isLoading) return <Splash />;

  async function onDelete(id: number, title: string) {
    const ok = await showConfirm(`Удалить сеанс «${title}»?`);
    if (ok) delMut.mutate(id);
  }

  return (
    <div className="min-h-screen pb-32">
      <TopBar title="Сеансы" />
      <div className="px-4 pt-3">
        <div className="flex gap-2 mb-3">
          <button
            onClick={() => setArchive(false)}
            className={`px-3 py-1.5 rounded-full text-xs ${!archive ? 'bg-accent text-white' : 'bg-bg-elev text-muted'}`}
          >
            Активные
          </button>
          <button
            onClick={() => setArchive(true)}
            className={`px-3 py-1.5 rounded-full text-xs ${archive ? 'bg-accent text-white' : 'bg-bg-elev text-muted'}`}
          >
            Архив
          </button>
        </div>
        <div className="space-y-2">
          {(data as any[])?.map((s) => (
            <div key={s.id} className="card p-4">
              <button
                className="block w-full text-left"
                onClick={() => navigate(`/admin/sessions/${s.id}/edit`)}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold">{s.title}</div>
                    <div className="text-xs text-muted mt-0.5">{s.cinema_name}</div>
                    <div className="text-xs text-muted mt-0.5">{formatDateTime(s.starts_at)}</div>
                  </div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-bg-elev">{s.status}</span>
                </div>
              </button>
              {!archive && (
                <div className="grid grid-cols-2 gap-2 mt-3">
                  <button
                    className="btn-secondary text-sm"
                    onClick={() => navigate(`/admin/sessions/${s.id}/edit`)}
                  >
                    Изменить
                  </button>
                  <button
                    className="btn-secondary text-sm !text-danger"
                    onClick={() => onDelete(s.id, s.title)}
                  >
                    Удалить
                  </button>
                </div>
              )}
            </div>
          ))}
          {!(data as any[])?.length && (
            <div className="text-muted text-center py-8">
              {archive ? 'Архив пуст' : 'Активных сеансов нет'}
            </div>
          )}
        </div>
      </div>
      {!archive && (
        <div className="fixed bottom-0 inset-x-0 p-4 bg-bg border-t border-line">
          <button className="btn-primary" onClick={() => navigate('/admin/sessions/new')}>
            + Новый сеанс
          </button>
        </div>
      )}
    </div>
  );
}
